import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface Calculator {
    startTime: string;
    endTime: string;
    units: number;
    timeDifference: string;
    timeDifferencePerPerson: string;
    errors: any;
    loading: boolean;
}

export class CalculatorData extends React.Component<RouteComponentProps<{}>, Calculator> {
    constructor(props: any) {
        super(props);

        this.state = {
            startTime: "06:30",
            endTime: "07:30",
            units: 2,
            timeDifference: "",
            timeDifferencePerPerson: "",
            errors: {},
            loading: false
        };


    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    validate = () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.startTime) {
            formIsValid = false;
            errors["startTime"] = "Start Time is required";
        }

        if (!fields.endTime) {
            formIsValid = false;
            errors["endTime"] = "End Time is required";
        }

        if (fields.units < 0) {
            formIsValid = false;
            errors["units"] = "Units > 0";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    calculateTime = () => {
        if (this.validate()) {
            this.calculateTimeDiff();
        }
    }

    async calculateTimeDiff() {
        const token = await authService.getAccessToken();

        axios.get('api/Admin/CalculateTimeDifference?startTime=' + this.state.startTime + "&endTime=" + this.state.endTime + "&people=" + this.state.units, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ timeDifference: res.data.timeDifference, timeDifferencePerPerson: res.data.timeDifferencePerPerson })
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    reset = () => {
        this.setState({
            startTime: "06:30",
            endTime: "07:30",
            units: 2,
            timeDifference: "",
            timeDifferencePerPerson: "",
            errors: {}
        })
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h3>Calculator</h3>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <label className="input-group" htmlFor="startTime">
                    <span className="label">Start Time</span>
                    <input type="time" className="input calculator__size" id="startTime" name="startTime" value={this.state.startTime} onChange={(e) => this.handleChange(e)} />
                </label>
                <span className="label errors">{this.state.errors["startTime"]}</span>

                <label className="input-group" htmlFor="endTime">
                    <span className="label">End Time</span>
                    <input type="time" className="input calculator__size" id="endTime" name="endTime" value={this.state.endTime} onChange={(e) => this.handleChange(e)} />
                </label>
                <span className="label errors">{this.state.errors["endTime"]}</span>

                <label className="input-group" htmlFor="units">
                    <span className="label">Units</span>
                    <input type="number" min="1" step="1" className="input calculator__size" id="units" name="units" value={this.state.units} onChange={(e) => this.handleChange(e)} />
                </label>
                <span className="label errors">{this.state.errors["people"]}</span>

                <button type="button" className="defaultbutton-prev marginBottom10" onClick={(e) => this.calculateTime()}>Calculate</button>
                <label className="input-group" htmlFor="timeDifference">
                    <span className="label">Time Difference</span>
                    <input type="text" className="input calculator__size" id="timeDifference" name="timeDifference" value={this.state.timeDifference} disabled />
                </label>
                <label className="input-group" htmlFor="timeDifferencePerPerson">
                    <span className="label">Per Unit</span>
                    <input type="text" className="input calculator__size" id="timeDifferencePerPerson" name="timeDifferencePerPerson" value={this.state.timeDifferencePerPerson} disabled />
                </label>
                <button type="button" className="defaultbutton-prev" onClick={(e) => this.reset()}>Reset</button>
            </div>
        );
    }

}